const appID = "394";

const useCreate = () => {
  return { appID };
};

export type Props = ReturnType<typeof useCreate>;

export default useCreate;
